import { InboxOutlined } from '@ant-design/icons';
import { Button, Modal, Typography, Upload } from 'antd';

import { useAppDispatch, useAppSelector } from '@/core/redux/hooks';
import { airExchangeTableSelectors } from '@/core/redux/slices/airExchangeTable/selectors';
import { airExchangeTableActions } from '@/core/redux/slices/airExchangeTable/slice';

const { Text, Title, Paragraph } = Typography;

const Explication: React.FC = () => {
  const { isRender, systemID } = useAppSelector(
    airExchangeTableSelectors.explicationModal
  );

  const dispatch = useAppDispatch();

  const closeModal = () => {
    dispatch(
      airExchangeTableActions.setExplicationModal({
        isRender: false,
      })
    );
  };

  const action = (info: any) => {
    dispatch(
      airExchangeTableActions.importOfExplication({
        id: systemID,
        formData: { file: info?.file },
      })
    );
  };

  return (
    <Modal
      title='Загрузить экспликацию'
      open={isRender}
      onCancel={closeModal}
      closable={false}
      cancelButtonProps={{ className: 'm-5 text-black' }}
      footer={null}
      width={550}
      centered
    >
      <Paragraph type='secondary'>
        Вы можете{' '}
        <Button
          type='link'
          htmlType='button'
          className='p-0 underline h-fit'
          onClick={() =>
            window.location.assign(
              'https://storage.yandexcloud.net/aeropro-static/shablon_tabliza_vozduhoobmena.xlsx'
            )
          }
        >
          скачать шаблон Excel
        </Button>{' '}
        для правильной загрузки экспликации. Работайте в привычной среде:
        заполните файл, добавьте необходимые данные или скопируйте их из других
        документов.
      </Paragraph>
      <Upload.Dragger multiple beforeUpload={() => false} onChange={action}>
        <p className='ant-upload-drag-icon'>
          <InboxOutlined />
        </p>
        <p className='ant-upload-text'>
          <span className='underline'>Нажмите</span> или перетащите файл, чтобы
          загрузить
        </p>
        <p className='ant-upload-hint'>
          Загрузите экспликацию на основе шаблона
        </p>
      </Upload.Dragger>
    </Modal>
  );
};

export const ExplicationModal: React.FC = () => {
  const { isRender } = useAppSelector(
    airExchangeTableSelectors.explicationModal
  );

  if (isRender) {
    return <Explication />;
  }

  return null;
};
